import React, { memo } from 'react'
import { Box } from '@node-space/ui-components'
import { ContactsListSkeletonLoader } from 'pages/Contacts/ContactsListSkeletonLoader'

const BeneficiaryListLoader = () => {
  return (
    <Box>
      {Array.from({ length: 20 }, (_, index) => (
        <ContactsListSkeletonLoader
          key={index}
          rows={1}
          hasBorder={false}
          addMeatballSkeleton={false}
        />
      ))}
    </Box>
  )
}

export default memo(BeneficiaryListLoader)
